<template>
  <!-- record -->
  <div class="receipt" style="font-family: '微软雅黑';">
    <div class="page" v-for="(item, index) in record.patientStickingDrugGroupList" :id='scriptInfo(index)'
      :key="index + 'info-title'">
      <!-- 处方信息 -->
      <div style="font-size: 8pt; line-height: 16pt;font-family: '微软雅黑';">
        <p style="float: left;">NO.{{ record.inquiryInfo.recordId }}</p>
        <div style="float: right;">
          <p style="display: inline-block;;float: right;">
            <span tdata="pageNO" format="#">##</span>/<span tdata="pageCount" format="#">##</span>
          </p>
          <p
            style="width:24pt;;float: right; text-align:center;height: 14pt;line-height: 14pt;border:1pt solid rgba(51,51,51,1);border-radius:3pt;display: inline-block;margin-right: 8pt;">
            普通</p>
        </div>
      </div>
      <div style="clear: both;"></div>
      <h3 style="text-align: center; font-size: 16pt;margin-top: 0;font-family: '微软雅黑';font-weight: normal;">
        {{ $store.state.global.countInfo.hospitalName }}</h3>
      <h4 style="text-align: center; font-size: 12pt;margin-top: -12pt;font-family: '微软雅黑';font-weight: normal;">贴敷笺
      </h4>
      <div class="user-info" style="margin-top: -8pt;font-size:8pt;font-family: '微软雅黑';font-size: 9pt;">
        <div style="border-bottom: 1pt solid #999; line-height: 24pt;height: 24pt;">
          <div style="display: inline-block;width: 33.333%; float: left;">
            姓名：{{ record.patient.patientName }}
          </div>
          <div style="display: inline-block;width: 33.333%; float: left;">
            性别：{{ record.patient.gender == -1 ? '未知' : (record.patient.gender == 0 ? '女' : '男') }}
          </div>
          <div style="display: inline-block;width: 33.333%; float: left;">
            年龄：
            <span v-if="record.inquiryInfo.clinicalAge">{{ record.inquiryInfo.clinicalAge }}</span>
            <span v-else>
              <span v-if="record.patient.year > 0">{{ record.patient.year }}岁</span>
              <span v-if="record.patient.month > 0 && record.patient.year >= 0 && record.patient.year < 5">{{
      record.patient.month }}月</span>
              <span v-if="record.patient.year === 0 && record.patient.day > 0">{{ record.patient.day }}天</span>
            </span>
          </div>
        </div>
        <div style="border-bottom: 1pt solid #999;; line-height: 24pt;height: 24pt;">
          <div style="display: inline-block;width: 33.333%; float: left;">
            手机号：{{ record.patient.phoneNo }}
          </div>
          <div style="display: inline-block;width: 33.333%; float: left;">
            科室：{{ record.inquiryInfo.laboratoryName }}
          </div>
          <div style="display: inline-block;width: 33.333%; float: left;">
            就诊日期：{{ record.inquiryInfo.clinicalTime }}
          </div>
          <div style="display: inline-block;width: 33.333%; float: left;">
          </div>
        </div>
        <div style="border-bottom: 1pt solid #999;line-height: 24pt;height: 24pt;">
          <div>
            临床诊断：{{ record.inquiryInfo.diagnosisResultString }}
          </div>
        </div>
        <div style="border-bottom: 1pt solid #999;line-height: 24pt;height: 24pt;">
          <div>
            过敏史：{{ record.inquiryInfo.allergyHistory }}
          </div>
        </div>
      </div>
      <!-- 字母 -->
      <div style="line-height: 11pt;">
        <h1 style="font-size: 16pt;display: inline-block;font-family:DFPSongW7;float:left;">R</h1>
        <h2 style="font-size: 12pt;display: inline-block;font-family:DFPSongW7;float:left;">p</h2>
      </div>
      <div style="clear: both;"></div>
    </div>
    <!-- 处方 -->
    <div class="page" v-for="(item, index) in record.patientStickingDrugGroupList" :id='idAdd(index)'
      :key="item.recordId">
      <!-- 敷贴处方 -->
      <TABLE border=0 cellSpacing=0 cellPadding=1 width="100%"
        style="border-collapse:collapse;font-size: 9pt;font-family: '微软雅黑';">
        <TBODY>
          <TR>
            <TD>
              <div style="width: 30%; float:left;margin-right: 3%; margin-bottom: 8pt;"
                v-for="(it) in item.patientStickingDrugList" :key="it.id + item.recordId">
                <span>{{ it.drugName }}</span> &nbsp;
                <span>{{ it.dosage }} {{ it.dosageUnit }}</span> &nbsp;
                <span v-if="it.comment">({{ it.comment }})</span>
              </div>
            </TD>
          </TR>
          <TR>
            <TD>
              <div style="border-top: 1pt dashed #999;padding-top: 8pt;">
                <div style="float: left;width: 24.5%;">用法：{{ item.usage }}</div>
                <div style="float: left;width: 24.5%;">调法：{{ item.adjusting }}</div>
                <div style="float: left;width: 24.5%;">时长：{{ item.minuteNumber }}分钟</div>
                <div style="float: left;width: 24.5%;">贴数：{{ item.count }}贴</div>
              </div>
            </TD>
          </TR>
          <TR>
            <TD>
              <div>
                部位： {{ item.position | joinArr }}
              </div>
            </TD>
          </TR>
        </TBODY>
      </TABLE>
    </div>
    <!-- 诊所信息 -->
    <div style="margin-top: 0px;font-size: 9pt;font-family: '微软雅黑';" id="footer-info-sticking">
      <div style="font-size: 9pt;border-bottom: 1pt solid #999; line-height: 24pt;height:24pt;font-family: '微软雅黑';">
        <div style="float: left; width: 49.99%;">
          医生：<span v-if="printConfig.printDoctorName == 1">{{ record.realName }}</span>
        </div>
        <div style="float: left; width: 49.99%;">
          敷贴总金额：<span v-if="printConfig.printTotalPrice == 1">￥{{ prescriptionAmt }}</span>
        </div>
      </div>
      <div style="clear: both;"></div>
      <div style="font-size: 9pt;border-bottom: 1pt solid #999;; line-height: 24pt;height:24pt;font-family: '微软雅黑';">
        <div style="float: left; width: 24.5%;">
          审查：
        </div>
        <div style="float: left; width: 24.5%;">
          调配：
        </div>
        <div style="float: left; width: 24.5%;">
          核对：
        </div>
        <div style="float: left; width: 24.5%;">
          发药：
        </div>
      </div>
      <div style="clear: both;"></div>
      <div style="font-size: 9pt;line-height: 24pt;height:24pt;font-family: '微软雅黑';">
        注：{{ printConfig.remark }}
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { getLodop } from '@/plugins/LodopFuncs.js';
import { BigNumber } from 'bignumber.js';
const BN = BigNumber.clone();
BN.config({ DECIMAL_PLACES: 2 });

export default {
  /** 
   *  type 的几种类型
   *  medicine -> 成药
   *  pieces -> 饮片
   *  infusion -> 输液
   *  apply -> 服帖
   *  infusionCard -> 输液卡
   *  other -> 其他
  */
  props: {
    record: {
      type: Object,
      default: {
        patientStickingDrugGroupList: [],
      },
    },
    isReview: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      printConfig: {
        printDoctorName: 0, // 是否打印名字
        printTotalPrice: 0, // 是否显示价格
        remark: 0, // 打印备注
      },
      hospitalName: '',
      printTime: '',
      cur_type: 'apply',
    }
  },
  methods: {
    print ({ isReview } = {}) {
      this.printTime = moment().format('YYYY-MM-DD HH:mm:ss');
      const { scriptValue } = this.$store.state.global.printConfig;
      this.$nextTick(() => {
        const LODOP = getLodop();
        LODOP.SET_LICENSES("", "94E6E7FFD51B8CCBE5F216686981579D", "C94CEE276DB2187AE6B65D56B3FC2848", "");
        LODOP.PRINT_INIT('敷贴打印');
        LODOP.SET_PRINT_PAGESIZE(1, '148mm', '210mm', 'record');
        this.record.patientStickingDrugGroupList.forEach((item, index) => {
          LODOP.ADD_PRINT_HTM(0, '5%', '90%', '50mm', document.getElementById(`${this.cur_type}-info` + index).innerHTML);
          LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
          LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
          LODOP.ADD_PRINT_HTM('75mm', '5%', '90%', '110mm', document.getElementById(this.cur_type + index).innerHTML);
          LODOP.ADD_PRINT_HTM('145mm', '5%', '90%', '50mm', document.getElementById('footer-info-sticking').innerHTML);
          LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
          LODOP.SET_PRINT_STYLEA(0, "LinkedItem", 1);
          LODOP.NewPageA();
        });
        LODOP.SET_PRINT_MODE("RESELECT_PRINTER", true);// 允许重选打印机
        LODOP.SET_PRINT_MODE("RESELECT_PAGESIZE", true); // 可以自行修改打印尺寸
        LODOP.SET_PRINT_MODE("AUTO_CLOSE_PREWINDOW", 1); // 打印后自动关闭预览窗口
        LODOP.SET_PRINTER_INDEX(scriptValue);
        // LODOP.PREVIEW();
        // if (isReview) {
          LODOP.PREVIEW();
        // } else {
        //   LODOP.PRINT();
        // }
      });
    },

    // 计算金额
    drugAmt (price, num) {
      const priceNumber = Number(price);
      const numNumber = Number(num);
      if (!priceNumber || isNaN(priceNumber) || isNaN(numNumber) || !numNumber) return '0.00';
      return BN(price).multipliedBy(num).toFixed(2);
    },
    // 获取打印配置
    getPrintConfig () {
      this.$api.clinicManagement.getPrintConfit({ configType: 6 }).then((res) => {
        this.printConfig = res;
      })
    },
    scriptInfo (index) {
      return `${this.cur_type}-info` + index;
    },
    idAdd (index) {
      return this.cur_type + index;
    },

  },
  filters: {
    joinArr (arr) {
      let newInfo = '';
      // console.log(arr);
      if (arr instanceof Array) {
        newInfo = arr.join(',');
      } else {
        try {
          JSON.parse(arr);
          newInfo = JSON.parse(arr).join(',');
        } catch (e) {
        }
      }

      return newInfo;
    },
  },
  computed: {
    laboratoryName () {
      return this.$store.state.global.countInfo.laboratoryName;
    },
    // 计算处方价格
    prescriptionAmt () {
      if (!this.record.patientStickingDrugGroupList || this.record.patientStickingDrugGroupList.length === 0) return '';
      const amt = this.record.patientStickingDrugGroupList.reduce((a, b) => {
        const itemPrice = b.retailPrice * b.count;
        return a + itemPrice;
      }, 0);
      return BN(amt).toFixed(2);
    },
  },
  mounted () {
    this.getPrintConfig();
  }
}
</script>
<style lang="scss" scoped>
.header-info {
  border-bottom: 2px solid #000000;
}

.receipt {
  width: 300px;
  justify-content: space-between;
}

span {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: #AAAAAA;
}

.receipt {
  position: fixed;
  border: 1pt solid #000000;
  z-index: 100;
  width: 1000px;
  background: white;
  left: -5000px;
  top: 100px;
}
</style>
